import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class CompanyUserGroup extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            companyId: props.CompanyId,
            caller: props.Caller,
            data: null,
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/company/usergroup/get", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        this.httpPost("api/v1/company/usergroup/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.companyId,
            title: this.state.data.record.title,
            permissions: this.state.data.record.permissions,
            code: this.state.data.record.code
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    } 

    setPermissions(e, id, parentId) {

        var permissions = this.state.data.record.permissions;

        //set child permissions
        if (parentId == null) {

            var pTop = "[" + id + "]";
            permissions = permissions.replace(pTop, "");
            if (e.target.checked) permissions += pTop;

            this.state.data.menus.forEach(menu => {
                if (menu.parentId === id) {
                    var p = "[" + menu.id + "]";
                    permissions = permissions.replace(p, "");
                    if (e.target.checked) permissions += p;
                }
            });
        }
        //change parent toggle
        else {
            var p = "[" + id + "]";
            var pTop = "[" + parentId + "]";
            permissions = permissions.replace(p, "");
            if (!permissions.includes(pTop))
                permissions += pTop;

            if (e.target.checked) {
                permissions += p;
            }
        }
        this.state.data.record.permissions = permissions;
        this.setState({
            loading: false
        });
    }
    checked(f) {
        var p = "[" + f + "]";
        return this.state.data.record.permissions.includes(p);
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات گروه" : "افزودن گروه جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-10 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">کد</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="10" />
                                        </div>
                                    </div>

                                    <ul className="nav nav-tabs mt-n3" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link active" data-bs-toggle="tab" href="#tab1" aria-selected="false" role="tab" tabindex="-1"><span>دسترسی های بر اساس منوها</span></a>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link" data-bs-toggle="tab" href="#tab2" aria-selected="false" tabindex="-1" role="tab"><span>دسترسی های عملیاتی</span></a>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="tab1" role="tabpanel">
                                            {this.state.data.menus.map(parent =>
                                                parent.type === 0 && parent.parentId === null && [<div className="col-sm-12 mt-2" style={{ "background-color": "azure" }} key={"parent_" + parent.id}>
                                                    <input onChange={e => this.setPermissions(e, parent.id, parent.parentId)} checked={this.checked(parent.id)} type="checkbox" /> {parent.title}
                                                </div>
                                                    ,
                                                <div className="row" style={{ "background-color": "aliceblue", "margin": "0", "padding": "10px 0 0 0" }} >
                                                    {this.state.data.menus.map(child => child.parentId === parent.id && <div className="col-sm-2" key={"child_" + child.id}>
                                                        <input onChange={e => this.setPermissions(e, child.id, child.parentId)} checked={this.checked(child.id)} type="checkbox" /> {child.title}
                                                    </div>)}
                                                </div>,
                                                <hr className="mt-2" />
                                                ]
                                            )}
                                        </div>
                                        <div className="tab-pane" id="tab2" role="tabpanel">
                                            {this.state.data.menus.map(parent =>
                                                parent.type === 1 && parent.parentId === null && [<div className="col-sm-12 mt-2" style={{ "background-color": "azure" }} key={"parent_" + parent.id}>
                                                    <input onChange={e => this.setPermissions(e, parent.id, parent.parentId)} checked={this.checked(parent.id)} type="checkbox" /> {parent.title}
                                                </div>
                                                ]
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}